import { useParams } from "react-router-dom";
import { useLanguageSync } from "@/hooks/useLanguage";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import JsonLd from "@/components/feature/JsonLd";
import { buildWebsiteSchema, buildOrganizationSchema } from "@/data/seo";
import Hero from "./components/Hero";
import Categories from "./components/Categories";
import About from "./components/About";
import Features from "./components/Features";
import Why from "./components/Why";
import ArticlesSection from "./components/ArticlesSection";
import ArticleCta from "./components/ArticleCta";
import Safety from "./components/Safety";
import Faq from "./components/Faq";
import CtaBanner from "./components/CtaBanner";

export default function Home() {
  const { lang = "en" } = useParams();
  useLanguageSync(lang);

  return (
    <>
      <JsonLd data={[buildWebsiteSchema(lang), buildOrganizationSchema(lang)]} />
      <div className="min-h-screen bg-background-50">
        <Navbar lang={lang} />
        <main>
          <Hero />
          <Categories />
          <About />
          <Features />
          <Why />
          <ArticlesSection lang={lang} />
          <ArticleCta lang={lang} />
          <Safety />
          <Faq />
          <CtaBanner />
        </main>
        <Footer lang={lang} />
      </div>
    </>
  );
}